package com.milta.feature.imports.domain.usecase

import com.milta.feature.imports.domain.entity.ImportResult
import com.milta.feature.imports.domain.entity.ImportType
import com.milta.feature.imports.domain.repository.ImportRepository

/** POST /api/v1/imports (DOM-02, écran A). */
class StartImportUseCase(private val repository: ImportRepository) {
    suspend operator fun invoke(fileBytes: ByteArray, fileName: String, importType: ImportType): ImportResult =
        repository.startImport(fileBytes, fileName, importType)
}
